<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 19.84a34.09 34.09 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      fill="#4f2b1b"
    />
    <path
      d="m33 51.7c-6.63.44-12.39 6.53-10 13.37 1.17 3.24 3.55 6.16 5.82 8.7.74.83 2.79 3.8 4.13 3.75s3.31-2.84 4.12-3.75c2.27-2.54 4.66-5.46 5.82-8.7 2.45-6.84-3.31-12.93-9.89-13.37zm0 16c-8.55-.46-8.63-13.36 0-13.36s8.5 12.93 0 13.39z"
      fill="#85c441"
    />
    <path
      d="m65 28.85c-3.12.21-5.83 3.07-4.68 6.29a13.11 13.11 0 0 0 2.74 4.1c.35.39 1.32 1.76 1.94 1.76s1.56-1.34 1.94-1.76a13.28 13.28 0 0 0 2.74-4.1c1.16-3.22-1.55-6.08-4.68-6.29zm0 7.54c-4-.21-4.06-6.28 0-6.28s4 6.07 0 6.28z"
      fill="#85c441"
    />
    <path
      d="m68.53 42.59a1.34 1.34 0 0 0 -1.82-.47l-1.43 1.05-.88-1.17a1.38 1.38 0 0 0 -1.82-.47 1.32 1.32 0 0 0 -.47 1.81l1 1.43-1.2.89a1.36 1.36 0 0 0 -.48 1.81 1.34 1.34 0 0 0 1.82.48l1.43-1.05.88 1.19a1.37 1.37 0 0 0 1.82.48 1.35 1.35 0 0 0 .48-1.82c-.35-.47-.7-.95-1.06-1.42l1.2-.89a1.38 1.38 0 0 0 .53-1.85z"
      fill="#4f2b1b"
    />
    <g fill="#85c441">
      <path d="m32.35 82.89h4.75c2.9 0 2.9-4.5 0-4.5h-4.75c-2.89 0-2.9 4.5 0 4.5z" />
      <path d="m42.5 82.6h4c2.7 0 2.71-4.2 0-4.2h-4c-2.7 0-2.71 4.2 0 4.2z" />
      <path d="m52.33 81.85 4.64-1c2.45-.54 1.41-4.3-1-3.76l-4.63 1c-2.45.54-1.42 4.3 1 3.76z" />
      <path
        d="m61.94 78.93 4-1.69a1.87 1.87 0 0 0 1.3-2.24 1.83 1.83 0 0 0 -2.24-1.24l-4 1.7a1.87 1.87 0 0 0 -1.26 2.21 1.82 1.82 0 0 0 2.22 1.26z"
      />
      <path d="m71.15 70.91v-3.41a1.65 1.65 0 0 0 -3.3 0v3.41a1.65 1.65 0 0 0 3.3 0z" />
      <path
        d="m68.56 61.44-3.12-2.6a1.54 1.54 0 0 0 -2.12 0 1.52 1.52 0 0 0 0 2.12l3.12 2.6a1.54 1.54 0 0 0 2.12 0 1.51 1.51 0 0 0 0-2.12z"
      />
      <path d="m60.52 56.23-4.62-1.18c-1.87-.47-2.67 2.42-.8 2.9l4.63 1.17c1.87.48 2.67-2.42.79-2.89z" />
      <path
        d="m52.15 54.56-2.85-3.8a1.37 1.37 0 0 0 -1.83-.48 1.35 1.35 0 0 0 -.47 1.83l2.85 3.79a1.37 1.37 0 0 0 1.83.48 1.34 1.34 0 0 0 .48-1.82z"
      />
      <path
        d="m48.33 47.58 3.83-2.81a1.38 1.38 0 0 0 .48-1.83 1.35 1.35 0 0 0 -1.83-.48l-3.81 2.81a1.38 1.38 0 0 0 -.48 1.83 1.35 1.35 0 0 0 1.83.48z"
      />
      <path
        d="m55.53 44.87 4.71.6a1.34 1.34 0 0 0 1.33-1.34 1.36 1.36 0 0 0 -1.33-1.33l-4.71-.61a1.35 1.35 0 0 0 -1.34 1.34 1.37 1.37 0 0 0 1.34 1.34z"
      />
    </g>
  </svg>
</template>
